var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"20px"}},[_vm._v("Redirecting to the privacy policy...")])
}
var staticRenderFns = []

export { render, staticRenderFns }